
import * as React from 'react';
import { SvgIcon } from '../svg-icon';
import heart from '../../assets/svg/heart.svg';
import * as style from './heart-animation.less';


export const HeartAnimation: React.StatelessComponent<{}> = (props) => {
	return (
		<div className={style.heartContainer}>
			<div className={style.burst}>
				{
					// array of 12 empty items so I can create 12 bursts
					['','','','','','','','','','','',''].map((item, index) => <div className={style.burstRay} key={`burst_${index}`} />)
				}
			</div>
			<div className={style.circle}>
				<SvgIcon svg={heart} className={style.heart}/>
			</div>
		</div>
	);
};
